import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

export const RichTextEditor = ({ value, onChange }) => {
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ align: [] }],
      ['link'],
    ],
  }

  const formats = [
    'header',
    'background',
    'bold',
    'color',
    'font',
    'size',
    'align',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
  ]

  return (
    <ReactQuill
      defaultValue={value}
      value={value}
      modules={modules}
      formats={formats}
      theme='snow'
      onChange={onChange}
    />
  )
}
